/* Het registratieformulier van de app in DRIE stappen, zoals de eigenaar het wil (2026-08-09):
   1 account, 2 bedrijfsgegevens, 3 documenten.

   WAAROM HIER EN NIET IN DE APP. De app rendert alle velden onder elkaar met eigen kopjes
   (Company, Contact, Address, Documents) en biedt geen stappen. Zijn instellingenscherm is
   bovendien niet te bedienen vanaf hier: het draait in een afgeschermd venster binnen Shopify.
   Dit script laat het formulier van de app intact en groepeert alleen wat er al staat.

   OPZET, met opzet defensief: groeperen gebeurt op de NAAM van het invoerveld, niet op de kopjes
   van de app. Kopjes zijn vertaalbaar en veranderen bij een app-update; veldnamen zijn de sleutels
   waarop de app zijn gegevens verwerkt en veranderen bijna nooit. Vindt het script de velden niet,
   dan doet het NIETS en blijft het gewone formulier gewoon werken. Een half werkende stappenbalk
   is erger dan geen stappenbalk.

   Er wordt niets verzonden of gewijzigd: alleen tonen en verbergen. */
(function () {
  /* Buiten start() zodat de gekozen stap een hertekening van de app overleeft. */
  var onthoudenStap = 0;
  /* Verwijzing naar de tonen-functie van de huidige opbouw, zodat de bewaker de zichtbaarheid kan
     herstellen zonder de hele stappenbalk opnieuw te bouwen (dat zou bij elke toetsaanslag
     knipperen). */
  var herstel = null;

  var STAPPEN = [
    { titel: 'Account', velden: ['contact_first_name', 'contact_last_name', 'contact_email', 'contact_phone', 'phone'] },
    { titel: 'Bedrijfsgegevens', velden: ['company_name', 'address_line1', 'address_line2', 'postal_code', 'city', 'country_code', 'chamber_of_commerce_number', 'vat_number', 'resale_certificate_number'] },
    { titel: 'Documenten', velden: ['chamber_of_commerce_document', 'resale_certificate_document', 'terms_accepted'] },
  ];

  function start() {
    var blok = document.querySelector('.b2b-registration-block');
    if (!blok || blok.hasAttribute('data-cv-stappen')) return;
    var form = blok.querySelector('form');
    if (!form) return;

    /* DUBBELE VELDEN. De app zet zijn eigen velden rechtstreeks in het formulier EN zet de door
       ons ingestelde velden nog eens neer in .b2b-registration-block__custom-fields. Elk veld
       bestaat daardoor twee keer met dezelfde naam. Zichtbaar werd dat in stap 2: bedrijfsnaam,
       adres en contactgegevens stonden er allemaal dubbel.
       We houden de versie uit __custom-fields aan, want die draagt de Nederlandse labels die in de
       app zijn ingesteld; de ingebouwde tweeling verbergen we. Alleen als er een tweeling IS: een
       ingebouwd veld zonder tegenhanger blijft gewoon staan, anders zou het veld verdwijnen zodra
       iemand in de app een veld weghaalt. */
    var eigenNamen = {};
    form.querySelectorAll('.b2b-registration-block__custom-fields input, .b2b-registration-block__custom-fields select, .b2b-registration-block__custom-fields textarea').forEach(function (v) {
      var n = (v.name || '').replace(/^registration\[|\]$/g, '');
      if (n) eigenNamen[n] = true;
    });

    /* Elk veld naar zijn stap. Een veld dat in geen enkele lijst staat (de app kan er later een
       toevoegen) gaat naar de LAATSTE stap: dan is het altijd zichtbaar voor verzenden, in plaats
       van stilletjes onbereikbaar. */
    var wikkels = [];
    form.querySelectorAll('input,select,textarea').forEach(function (veld) {
      if (veld.type === 'hidden') return;
      var wikkel = veld.closest('.b2b-registration-block__field, .b2b-registration-block__row, .b2b-registration-block__checkbox-wrap') || veld.parentElement;
      if (!wikkel || wikkels.indexOf(wikkel) !== -1) return;
      var eigenNaam = (veld.name || '').replace(/^registration\[|\]$/g, '');
      if (eigenNaam && eigenNamen[eigenNaam] && !wikkel.closest('.b2b-registration-block__custom-fields')) {
        wikkel.hidden = true;
        return;
      }
      /* De sjabloonkopie die de app eerst neerzet staat op display:none en heeft geen afmetingen.
         Die overslaan, anders krijgt de onzichtbare kopie de stap en blijft de echte staan. */
      if (wikkel.getClientRects().length === 0 && !wikkel.hidden) return;
      var naam = (veld.name || '').replace(/^registration\[|\]$/g, '');
      var index = STAPPEN.length - 1;
      for (var i = 0; i < STAPPEN.length; i++) {
        if (STAPPEN[i].velden.indexOf(naam) !== -1) { index = i; break; }
      }
      /* Het adresveld met automatisch aanvullen heeft GEEN naam (de app vult straat, postcode en
         plaats pas na de keuze in). Zonder deze regel valt het door de terugval in de laatste stap,
         dus tussen de documenten, terwijl het bij de bedrijfsgegevens hoort. */
      if (!naam && wikkel.className.indexOf('address') !== -1) index = 1;
      wikkel.__cvStap = index;
      wikkels.push(wikkel);
    });
    if (wikkels.length < 6) return;

    var knopBalk = form.querySelector('button[type="submit"]');
    if (!knopBalk) return;

    /* Kopjes van de app uit: ze horen bij de oude indeling en zouden nu midden in een stap staan. */
    form.querySelectorAll('.b2b-registration-block__section-heading').forEach(function (k) { k.hidden = true; });

    /* De stap onthouden over een hertekening heen. Zonder dit springt iemand die in stap 2 een veld
       invult terug naar stap 1 zodra de app zijn formulier opnieuw opbouwt. */
    var huidige = Math.min(onthoudenStap, STAPPEN.length - 1);
    var wijzer = document.createElement('ol');
    wijzer.className = 'cv-b2bstap__wijzer';
    STAPPEN.forEach(function (s, i) {
      var li = document.createElement('li');
      li.textContent = (i + 1) + '. ' + s.titel;
      wijzer.appendChild(li);
    });
    form.insertBefore(wijzer, form.firstChild);

    var nav = document.createElement('div');
    nav.className = 'cv-b2bstap__nav';
    var terug = document.createElement('button');
    terug.type = 'button'; terug.className = 'cv-b2bstap__terug'; terug.textContent = 'Terug';
    var verder = document.createElement('button');
    verder.type = 'button'; verder.className = 'cv-b2bstap__verder'; verder.textContent = 'Volgende';
    nav.appendChild(terug); nav.appendChild(verder);
    knopBalk.parentNode.insertBefore(nav, knopBalk);

    function toon() {
      /* NIET alleen het attribuut hidden. Gemeten op de live pagina (2026-08-09): de app WIST het
         attribuut hidden zodra iemand in een veld typt, en dan stond het hele formulier weer als
         een lange lijst op het scherm. De eigen klasse overleeft dat wel, en de bewaker hieronder
         zet hem terug voor het geval de app ooit de hele class-waarde overschrijft. */
      wikkels.forEach(function (w) {
        var uit = w.__cvStap !== huidige;
        w.hidden = uit;
        w.classList.toggle('cv-stap-uit', uit);
      });
      [].forEach.call(wijzer.children, function (li, i) {
        li.classList.toggle('is-nu', i === huidige);
        li.classList.toggle('is-klaar', i < huidige);
        if (i === huidige) { li.setAttribute('aria-current', 'step'); } else { li.removeAttribute('aria-current'); }
      });
      terug.hidden = huidige === 0;
      verder.hidden = huidige === STAPPEN.length - 1;
      /* De verzendknop mag alleen op de laatste stap staan, anders verstuurt iemand het formulier
         voordat hij zijn bedrijfsgegevens heeft ingevuld. */
      knopBalk.hidden = huidige !== STAPPEN.length - 1;
      knopBalk.classList.toggle('cv-stap-uit', huidige !== STAPPEN.length - 1);
    }
    herstel = toon;

    verder.addEventListener('click', function () {
      /* Alleen de velden van DEZE stap controleren; de rest is verborgen en een browser weigert
         een verborgen veld te valideren, wat een stille blokkade zou geven. */
      var mis = null;
      wikkels.forEach(function (w) {
        if (w.__cvStap !== huidige || mis) return;
        w.querySelectorAll('input,select,textarea').forEach(function (v) {
          if (!mis && v.required && !v.checkValidity()) mis = v;
        });
      });
      if (mis) { mis.reportValidity(); return; }
      if (huidige < STAPPEN.length - 1) { huidige++; onthoudenStap = huidige; toon(); form.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    terug.addEventListener('click', function () {
      if (huidige > 0) { huidige--; onthoudenStap = huidige; toon(); form.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });

    blok.setAttribute('data-cv-stappen', 'aan');
    toon();
  }

  /* HET BLOK WORDT IN MEER DAN EEN RONDE OPGEBOUWD. Gemeten op de live pagina: de app zet eerst
     een verborgen sjabloonversie van elk veld neer en vervangt die daarna door de echte velden.
     Een script dat een momentopname neemt, groepeert dus de verkeerde set en dan verandert er
     zichtbaar niets. Daarom kijken we mee tot de app klaar is, en groeperen we opnieuw zodra er
     velden bijkomen.

     WE BLIJVEN KIJKEN, de hele bezoektijd. Eerder stopte de waarnemer na twaalf seconden. Dat leek
     genoeg, maar de app tekent zijn formulier ook OPNIEUW terwijl iemand zit te typen (bij het
     invullen van een veld), en dan waren de stappen weg en stond het hele formulier er weer in een
     lange lijst. Precies wat de eigenaar in zijn video liet zien: "hij blijft altijd, het klopt
     niet". Meekijken kost niets zolang we onszelf tijdens het eigen werk stilzetten. */
  var opnieuw;
  var waarnemer = null;
  function hergroepeer() {
    /* Even niet meekijken: we gaan zelf de boom aanpassen (stappenbalk, knoppen, verbergen) en
       anders roept elke eigen wijziging zichzelf opnieuw aan. */
    if (waarnemer) waarnemer.disconnect();
    var blok = document.querySelector('.b2b-registration-block');
    if (blok) blok.removeAttribute('data-cv-stappen');
    var oude = document.querySelector('.cv-b2bstap__wijzer');
    if (oude) oude.remove();
    var oudeNav = document.querySelector('.cv-b2bstap__nav');
    if (oudeNav) oudeNav.remove();
    start();
    if (waarnemer && blok) waarnemer.observe(blok, KIJKOPTIES);
  }

  /* De goedkope bewaker: is de stappenbalk er nog, dan alleen de zichtbaarheid terugzetten. Pas als
     de balk weg is (de app heeft het formulier echt opnieuw opgebouwd) doen we de volle ronde. */
  function bewaak() {
    var blok = document.querySelector('.b2b-registration-block');
    if (!blok) return;
    var balk = blok.querySelector('.cv-b2bstap__wijzer');
    if (!balk || !herstel) { hergroepeer(); return; }
    if (waarnemer) waarnemer.disconnect();
    herstel();
    if (waarnemer) waarnemer.observe(blok, KIJKOPTIES);
  }

  var KIJKOPTIES = { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] };

  function kijkMee() {
    var blok = document.querySelector('.b2b-registration-block');
    if (!blok) return false;
    if (!waarnemer) {
      waarnemer = new MutationObserver(function () {
        clearTimeout(opnieuw);
        opnieuw = setTimeout(bewaak, 60);
      });
    }
    hergroepeer();
    return true;
  }

  var pogingen = 0;
  var timer = setInterval(function () {
    pogingen++;
    if (kijkMee() || pogingen > 40) clearInterval(timer);
  }, 250);
  document.addEventListener('DOMContentLoaded', kijkMee);
})();
